import * as React from "react";
import { Callout } from "@octopusdeploy/design-system-components";

interface AdministratorRoleCalloutProps {
    action: string;
}

export function AdministratorRoleCallout({action}: AdministratorRoleCalloutProps) {
    return <Callout type="information" title="Administrator role required">
        The <strong>Administrator</strong> role is required to {action}.
    </Callout>;
}
